var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/** Returns true if the response should be cached */
export function shouldCacheResponse(response, _a) {
    var cachePredicate = _a.cachePredicate;
    if (typeof cachePredicate === 'function') {
        return cachePredicate(response);
    }
    return isCachePredicateValid(response, cachePredicate);
}
export function isCachePredicateValid(response, _a) {
    var statusCheck = _a.statusCheck, containsHeaders = _a.containsHeaders, responseMatch = _a.responseMatch;
    if (statusCheck) {
        if (typeof statusCheck === 'function') {
            if (!statusCheck(response.status)) {
                return false;
            }
        }
        else {
            var _b = __read(statusCheck, 2), start = _b[0], end = _b[1];
            if (response.status < start || //
                response.status > end) {
                return false;
            }
        }
    }
    if (containsHeaders) {
        for (var headerName in containsHeaders) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var value = containsHeaders[headerName];
            var header = response.headers[headerName];
            // At any case, if the header is not found, the predicate fails.
            if (!header) {
                return false;
            }
            switch (typeof value) {
                case 'string':
                    if (header != value) {
                        return false;
                    }
                    break;
                case 'function':
                    if (!value(header)) {
                        return false;
                    }
                    break;
            }
        }
    }
    if (responseMatch && !responseMatch(response.data)) {
        return false;
    }
    return true;
}
